module.exports = __webpack_public_path__ + "img/pro_fourteen_5.67a6f70d.jpg";